
import ServicePage from '../../images/ServicePage.png';
export default function Service(){
    return (<>
   <img src={ServicePage} style={{width:'100%'}}></img>
    </>)
}